import React from "react";
import styled from "styled-components";
import { TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import axios from "axios";
import translate from "../../providers/i18n/translate";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

/* Styled components */

const StyledAutocomplete = styled(Autocomplete)`
  width: 100%;
  @media (min-width: 1024px) {
    width: ${(props) => (props.width ? props.width : "inherit")};
  }
`;
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const AutocompleteInput = ({
  label,
  name,
  value,
  onChange,
  width,
  size,
  margin,
  fieldlabel,
  fieldvalue,
  fieldextra1,
  fieldextra2,
  dataurl,
  required,
  disabled,
  subfield,
  withCredentials,
}) => {
  const [options, setOptions] = React.useState(null);

  const [search, setSearch] = React.useState("");

  const handleChange = (event, newValue) => {
    onChange(name, newValue);
  };

  React.useEffect(() => {
    if (!options) {
      axios
        .get(dataurl, { withCredentials: withCredentials ? true : false })
        .then((result) => {
          const dataRows = subfield ? result.data[subfield] : result.data;
          const opts = dataRows.map((opt) => {
            return {
              label: fieldlabel ? opt[fieldlabel] : null,
              value: fieldvalue ? opt[fieldvalue] : null,
              extra1: fieldextra1 ? opt[fieldextra1] : null,
              extra2: fieldextra2 ? opt[fieldextra2] : null,
              key: opt["key"],
            };
          });
          setOptions(opts);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [options]);

  return options ? (
    <StyledAutocomplete
      value={value}
      onChange={handleChange}
      inputValue={search}
      onInputChange={(event, newInputValue) => {
        setSearch(newInputValue);
      }}
      width={width}
      size={size}
      disabled={disabled}
      id={`id_autocomplete_${name}`}
      options={options}
      getOptionLabel={(option) => option.label}
      renderInput={(params) => (
        <TextField
          {...params}
          label={translate(label)}
          variant="outlined"
          required={required}
          margin={margin}
          disabled={disabled}
        />
      )}
      multiple
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option.label}
        </li>
      )}
    />
  ) : (
    <Box sx={{ width: "45%" }}>
      <Skeleton variant="h2" />
    </Box>
  );
};

export default AutocompleteInput;
